import { useCustomQuery } from "@/hooks/useCustomQuery"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { DetailTable } from "@/components/Tables/DetailTable"
import { columns } from "@/pages/orders/DetailColumns"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  Divider,
} from "@mui/material"
import { useParams, Link } from "react-router-dom"
import { useState, useEffect } from "react"
import Loading from "@/components/Loading"
import DataTable from "@/components/Tables/DataTable"

const CustomerDetails = () => {
  const { id } = useParams()

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useCustomQuery(["customer-detail", id], `customer/${id}`)

  if (isLoading) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center">
        <Loading />
      </div>
    )
  }

  const customer = response?.data
  return (
    <div>
      <div className="breadcrumb-card">
        <h5>Customer Details</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="//">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/customers">Customers</Link>
          </li>
          <li>{customer.name}</li>
        </ul>
      </div>
      {customer ? (
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-4 xxl:tw-grid-cols-5 tw-gap-6">
          <div className="card border rounded-3 lg:col-span-3 xxl:col-span-4">
            <OrderTable customer={customer} isLoading={isLoading} />
          </div>
          <div className="card bg-white border-0 ps-5 rounded-3 mb-4">
            <div className="card-body p-4">
              <div className="flex align-items-center mb-3 mb-lg-4">
                <div className="flex align-items-center">
                  <DetailAvatar name={customer.name} />
                </div>
              </div>

              <div className="mb-3">
                <p>Account ID:</p>
                <span className="d-block fw-medium mt-1 text-black ">
                  {customer.id}
                </span>
              </div>

              <div className="mb-3">
                <p>Email:</p>
                <span className="d-block fw-medium mt-1 text-black ">
                  {customer.email}
                </span>
              </div>

              <div className="mb-3">
                <p>Phone:</p>
                <span className="d-block fw-medium mt-1 text-black ">
                  {customer.phone}
                </span>
              </div>

              <div className="mb-3">
                <p>Created By:</p>
                <span className="d-block fw-medium mt-1 text-black">
                  {customer.createdBy.name}
                </span>
              </div>

              <div className="mb-3">
                <p>Updated By:</p>
                <span className="d-block fw-medium mt-1 text-black">
                  {customer.updatedBy.name}
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No user data found.</div>
      )}
    </div>
  )
}
function OrderTable({ customer, isLoading }) {
  return (
    <>
      <DataTable
        label="Orders"
        columns={columns}
        data={customer.orders}
        isLoading={isLoading}
      />
    </>
  )
}

export default CustomerDetails
